import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'
import App from './components/App';
import { AppProvider } from './contexts/app';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AppProvider>
  </React.StrictMode>
);

